import { request } from '@umijs/max';
// import { config } from '@/utils/config';
// import qs from 'qs';

/**
 *
 * @param data 房屋租赁
 * @returns
 */
export const getWechatRentPage = async (params?: any) => {
  return request('/api/community/wechat/WechatRent/page', {
    method: 'get',
    params,
  });
};

/**
 * 发布租赁
 * 
 */

export const addWechatRent = async (data?: any) => {
  return request('/api/community/wechat/WechatRent', {
    method: 'post',
    data,
  });
};

/**
 * @desc 通用上传
 * @param data
 */
export const queryCommonUpload = (data: any) =>{
  return request('/api/community/common/uploads', {
    method: 'post',
    data,
  });
}

/**
 * 查询详情
 */

export const getWechatRentDetail = (sequenceNbr: any) =>{
  return request(`/api/community/wechat/WechatRent/${sequenceNbr}`, {
    method: 'get'
  });
}

/**
 * 更新
 */

export const updateWechatRent = (data: any) =>{
  return request(`/api/community/wechat/WechatRent/${data.sequenceNbr}`, {
    method: 'put',
    data
  });
}


/**
 * 删除
 */

export const removeWechatRent = (ids: any) =>{
  return request(`/api/community/wechat/WechatRent/${ids}`, {
    method: 'delete'
  });
}

/**
 * 事件配置树查询
 * @param params
 */
export const getEventConfigTree = (params: any) => {
  return request('/api/community/ticket/category/tree',{
      method: 'get',
      params,
    })
};